export default __webpack_public_path__ + "static/media/Logo.c4177445.png";